const formatPrice = price => new Intl.NumberFormat('cs-CZ', {style: 'currency', currency: 'CZK'}).format(
    price,
)

const translateArrayKey = (array, t, key = 'label') => {
    return array.map(item => {
        item[key] = t(item[key]);
        return item;
    });
}

const getTranslatedDefaultOption = (array, value, t) => {
    const item = array.find(item => item.value === value);
    if (item) {
        item['label'] = t(item['label']);
        return item;
    }
    return '';
}

const slugify = (s) =>
    s.toString()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');


export {
    formatPrice,
    translateArrayKey,
    getTranslatedDefaultOption,
    slugify
}